declare var AWS: any;

export class UserComment {
    //this is NOT the same as user sub, it is identity sub for IAM
    private UserSub: string = null;
    public CommentDate:string;// = new Date().toISOString();
    public ReplyToId:string = "0";
    public CommentId:string;
    public AvatarURL:string = null;
    public AvatarKey:string;
    public UserName:string;
    public Votes:number;
    
    public Comment:string = "";

    //constructor(private PostId,
      //  private userName:string)
    constructor(private PostId)
    {
        //this.sub = AWS.config.credentials.identityId;
    }
  }


// WEBPACK FOOTER //
// ./src/providers/comment.ts